window.TmSearchShortcuts = (function () {
  'use strict';

  var STORAGE_KEY = 'tm_recent_searches';
  var MAX_RECENT = 5;

  function normalize(term) {
    if (typeof tmNormalizeSearchQuery === 'function') {
      return tmNormalizeSearchQuery(String(term || '').trim());
    }
    return String(term || '').trim();
  }

  function getRecent() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (error) {
      return [];
    }
  }

  function save(term) {
    term = normalize(term);
    if (!term) return;

    var recent = getRecent().filter(function (item) {
      return item.toLowerCase() !== term.toLowerCase();
    });

    recent.unshift(term);

    if (recent.length > MAX_RECENT) {
      recent = recent.slice(0, MAX_RECENT);
    }

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(recent));
    } catch (error) {
      /* ignore quota errors */
    }
  }

  function clear() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      /* ignore */
    }
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function parsePopular(element) {
    if (!element) return [];

    var raw = element.getAttribute('data-popular-searches') || '';

    if (!raw) return [];

    try {
      var parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        return parsed.map(function (item) {
          return String(item || '').trim();
        }).filter(Boolean);
      }
    } catch (error) {
      /* fall through */
    }

    return raw.split(',').map(function (item) {
      return item.trim();
    }).filter(Boolean);
  }

  function renderChips(container, terms) {
    if (!container) return;

    container.innerHTML = terms.map(function (term) {
      return (
        '<button type="button" class="tm-search-shortcuts__chip" data-term="' +
        escapeHtml(term) +
        '">' +
        escapeHtml(term) +
        '</button>'
      );
    }).join('');
  }

  function buildMarkup(labels) {
    labels = labels || {};

    return (
      '<div class="tm-search-shortcuts predictive-search absolute bg-theme-bg text-theme-text text-start">' +
        '<div class="tm-search-shortcuts__inner">' +
          '<div class="tm-search-shortcuts__section js-tm-recent-section" hidden>' +
            '<div class="tm-search-shortcuts__header">' +
              '<span class="tm-search-shortcuts__title h6">' +
                escapeHtml(labels.recent || 'Son arananlar') +
              '</span>' +
              '<button type="button" class="tm-search-shortcuts__clear link" data-tm-clear-recent>' +
                escapeHtml(labels.clear || 'Temizle') +
              '</button>' +
            '</div>' +
            '<div class="tm-search-shortcuts__chips js-tm-recent-chips"></div>' +
          '</div>' +
          '<div class="tm-search-shortcuts__section js-tm-popular-section">' +
            '<div class="tm-search-shortcuts__header">' +
              '<span class="tm-search-shortcuts__title h6">' +
                escapeHtml(labels.popular || 'Popüler aramalar') +
              '</span>' +
            '</div>' +
            '<div class="tm-search-shortcuts__chips js-tm-popular-chips"></div>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function updatePanel(panel, popularTerms) {
    if (!panel) return;

    var recentSection = panel.querySelector('.js-tm-recent-section');
    var popularSection = panel.querySelector('.js-tm-popular-section');
    var recentChips = panel.querySelector('.js-tm-recent-chips');
    var popularChips = panel.querySelector('.js-tm-popular-chips');
    var recent = getRecent();
    var popular = popularTerms || [];

    if (recent.length) {
      recentSection.hidden = false;
      renderChips(recentChips, recent);
    } else {
      recentSection.hidden = true;
      if (recentChips) recentChips.innerHTML = '';
    }

    if (popular.length) {
      popularSection.hidden = false;
      renderChips(popularChips, popular);
    } else {
      popularSection.hidden = true;
      if (popularChips) popularChips.innerHTML = '';
    }
  }

  function productPath(product) {
    if (!product) return null;

    if (product.url) {
      try {
        return new URL(product.url, window.location.origin).pathname;
      } catch (error) {
        return String(product.url).split('?')[0];
      }
    }

    if (product.handle) {
      return '/products/' + product.handle;
    }

    return null;
  }

  async function navigateToTopProduct(term, options) {
    options = options || {};
    term = normalize(term);
    if (!term) return false;

    save(term);

    var searchFields = options.searchFields || 'title,product_type,variants.title,tag';
    var suggestBase = options.suggestBase || '/search/suggest';
    var suggestUrl = suggestBase.indexOf('.json') === suggestBase.length - 5
      ? suggestBase
      : suggestBase + '.json';
    var searchUrl = options.searchUrl || '/search';
    var params =
      'q=' + encodeURIComponent(term) +
      '&resources[type]=product' +
      '&resources[limit]=1' +
      '&resources[options][fields]=' + encodeURIComponent(searchFields);

    try {
      var response = await fetch(suggestUrl + '?' + params);
      if (!response.ok) throw new Error(String(response.status));

      var data = await response.json();
      var products =
        data.resources &&
        data.resources.results &&
        data.resources.results.products
          ? data.resources.results.products
          : [];
      var path = productPath(products[0]);

      if (path) {
        window.location.href = path;
        return true;
      }
    } catch (error) {
      /* fall through to search page */
    }

    window.location.href =
      searchUrl +
      (searchUrl.indexOf('?') === -1 ? '?' : '&') +
      'q=' + encodeURIComponent(term) +
      '&type=product';
    return true;
  }

  return {
    getRecent: getRecent,
    save: save,
    clear: clear,
    parsePopular: parsePopular,
    buildMarkup: buildMarkup,
    updatePanel: updatePanel,
    navigateToTopProduct: navigateToTopProduct,
  };
})();
